// extracted by mini-css-extract-plugin
export default {"wrapper":"j8xh4i","title":"iyoHLg","subTitle":"bPt3gn"};